export default () => Component(function ($context) {
	return $context.select('.productgroups');
}, function ($productgroups, self) {
	var _private = {
		init: function() {
			_private.initEventListeners();
			_private.initHiddenItemsToggler();
		},
		initEventListeners: function() {
			$productgroups.on('click', '.productgroups__toggler', function (e) {
				const $toggler = $(this);
				const $parent = $toggler.closest('.productgroups__group');
				const isToggleLink = !!$toggler.closest('.productgroups__link').length;
				const isShow = $parent.hasClass('productgroups__group--show');

				if (isShow && isToggleLink) {
					return
				}

				e.preventDefault();
				$parent.toggleClass('productgroups__group--show');
			});

			$(window).on('resize', _private.initHiddenItemsToggler);
		},
		getHiddenItems: function($group) {
			const $items = _private.getGroupItems($group);
			const $oneItem = $items.first();
			const itemHeight = $oneItem.outerHeight();
			let $lastVisibleItem = undefined;
			let hiddenItemsCount = 0;

			$items.each(function () {
				const $item = $(this);
				const itemPos = $item.position();
				const itemTopPos = itemPos.top;

				if (itemTopPos >= itemHeight) {
					hiddenItemsCount += 1;
				} else {
					$lastVisibleItem = $item
				};
			});

			$items.removeClass('.productgroups__toggler');

			return {$lastVisibleItem, hiddenItemsCount};
		},
		initHiddenItemsToggler: function () {
			_private.getPhotoGroups().each(function () {
				const $group = $(this);
				const {$lastVisibleItem, hiddenItemsCount} = _private.getHiddenItems($group);

				$group.find('> .productgroups__toggler').remove();
				$group.find('.productgroups__hidden-count').remove();

				if (hiddenItemsCount > 0) {
					$group.append('<div class="productgroups__toggler"><span class="link-underlined">Свернуть</span></div>');
					$lastVisibleItem.append('<span class="productgroups__hidden-count">+'+hiddenItemsCount+'</span>');
				} else {
					$lastVisibleItem.find('.productgroups__hidden-count').remove();
				}

				$lastVisibleItem.toggleClass('productgroups__toggler', hiddenItemsCount > 0);
			})
		},
		getGroupItems: function($group) {
			return $group.find('.productgroups__link');
		},
		getPhotoGroups: function() {
			return $productgroups.find('.productgroups__group--photos');
		}
	};

	_private.init();
})
